import { Component, EventEmitter, Inject, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwContainerOptions, DwContext, DwExpressionService, DwFormActionInterceptResult, DwFormActionInterceptor, DwFormActionKeys, DwFormContextMode, DwMdFormContextInfo, DwMessage, DwMessageSeverity, DwMetaDataFormApi, DwMetaDataFormConfig, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwSectionBasePreference, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwUiConfigRegistryService, deepCopy, formatDateTimeFromLocal } from '@devwareapps/devware-cap';
import { Observable, Subscription, combineLatest, of } from 'rxjs';

import { AppMetaData, AppMetaDataItemNames, ApplicantAcsWrittenResultEntity, ApplicantPlaceholderEntity, CheckRideOutcomeAllItems, CheckRideRequestEntity, CheckRideRequestSubStatusAllItems, CheckRideResultEntity, CheckRideScenarioEntity, PilotExaminerLocationEntity, PilotExaminerSearchQueryEntity, StudentApplicantEntity } from '../../../../meta-data/app-meta-data.service';
import { ExaminerRepositoryService } from '../../../examiner/services/examiner-repository.service';
// import { CheckrideVariables } from '../../models/checkride-variables.model';
import { ApplicantRepositoryService } from '../../services/applicant-repository.service';
import { CheckCalendarAvailabilityRequestDTO } from '../../../examiner/models/check-calendar-availability-request.model';
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { CurrentStudentContext } from 'src/app/features/shared/contexts/current-student-context/current-student-context.service';
import { CheckCalendarAvailabilityResultDTO } from '../../../examiner/models/check-calendar-availability-result.model';
import { map, mergeMap } from 'rxjs/operators';
import { CheckrideValidationResult } from '../../models/checkride-validation-result.model';
import { PlanOfActionRepositoryService } from '../../../plan-of-action/services/plan-of-action-repository.service';
import { ExaminerBookingVariableContext } from '../../../booking/models/examiner-booking-variable-context.model';

@DwComponent({
  key: 'applicant-check-ride-util',
  name: ' Applicant Check Ride Util',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.CheckRideRequest,
  isGlobal: false
})
@Component({
  selector: 'app-applicant-check-ride-util',
  template: `
  `
})
export class ApplicantCheckRideUtilComponent extends DwSectionBaseComponent {
  checkRideRequest: CheckRideRequestEntity;

  originalCheckRideRequest: CheckRideRequestEntity;

  rebookSetupComplete = false;
  formApi: DwMetaDataFormApi;
  applicantDataUpdated: boolean;
  applicantCheckride: CheckRideRequestEntity;
  examinerScheduleRechecked: boolean;
  activeCheckrideChecked: boolean;
  lastCheckRideRequest: CheckRideRequestEntity;
  testTypes: import("c:/Projects/DevwareGit/Pilexos/PilexosCAPAngular/src/app/meta-data/app-meta-data.service").CheckRideTestTypeEntity[];
  outcomes: import("c:/Projects/DevwareGit/Pilexos/PilexosCAPAngular/src/app/meta-data/app-meta-data.service").CheckRideOutcomeEntity[];
  allAcsTests: import("c:/Projects/DevwareGit/Pilexos/PilexosCAPAngular/src/app/meta-data/app-meta-data.service").AcsTestCheckRideTypeEntity[];

  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private examinerRepositoryService: ExaminerRepositoryService,
    private applicantRepositoryService: ApplicantRepositoryService,
    private dateTimeUtilService: DateTimeUtilService,
    private planOfActionRepositoryService: PlanOfActionRepositoryService
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);

    this.formApi = this.dwMetaDataFormStateService.state.formApi;
  }

  ngOnInit(): void {
    this.setupDataWatch();

    this.setupFormActionInterceptor();
    this.loadReferenceData();
  }

  loadReferenceData() {
    const testTestsOb = this.examinerRepositoryService.getCheckrideTestTypes();
    const outcomesOb = this.examinerRepositoryService.getCheckrideOutcomes();
    const allAcsTestsOb = this.planOfActionRepositoryService.getAcsTestByCheckRideTypeAll();

    combineLatest([testTestsOb, outcomesOb, allAcsTestsOb]).subscribe(([testTypes, outcomes, allAcsTests]) => {
      this.testTypes = testTypes;
      this.outcomes = outcomes;
      this.allAcsTests = allAcsTests;
    });
  }

  formActionInterceptor: DwFormActionInterceptor

  setupFormActionInterceptor() {
    this.formActionInterceptor = {
      interceptorName: 'applicantCheckRideUtil',
      order: 1,
      onBeforeActionWait: true,
      onBeforeAction: (actionPref, actionConfig) => {

        // Note: Payment Util form inteceptor runs after this and handles the payment validation (it also saves the checkride before showing the payment modal)
        const result: DwFormActionInterceptResult = {
          abort: false
        }

        if (actionPref.actionKey != DwFormActionKeys.formWorkflow) {
          return of(result);
        }

        const validationResult = this.dwMetaDataFormStateService.state.formApi.validateForm();

        if (!validationResult.isValid) {
          result.abort = true;
          result.message = this.dwMetaDataFormStateService.state.formApi.createValidationMessage(validationResult);

          return of(result);
        }

        // Moved to payment util
        return this.validateCheckride()
          .pipe(mergeMap(validationResult => {

            if (!validationResult.IsSuccess) {
              result.abort = true;
              result.message = validationResult.Message;

              return of(result);
            }

            return this.validateScheduleOnSave();
          }));
      }
    }

    // Register the action interceptor with the form
    this.dwMetaDataFormStateService.addActionInterceptor(this.formActionInterceptor);
  }

  validateCheckride(): Observable<CheckrideValidationResult> {
    return this.applicantRepositoryService.validateActiveCheckrides(this.checkRideRequest);
  }

  validateScheduleOnSave(): Observable<DwFormActionInterceptResult> {
    const result: DwFormActionInterceptResult = {
      abort: false,
    }
    if (!this.originalCheckRideRequest) {

      return of(result);
    }


    // if (this.formApi.getFormConfig().formMode != DwFormContextMode.edit) {
    //   return of(result);
    // }

    if (this.originalCheckRideRequest?.CheckRideRequestSubStatusId != CheckRideRequestSubStatusAllItems.Draft &&
      this.originalCheckRideRequest?.CheckRideRequestSubStatusId != CheckRideRequestSubStatusAllItems.PendingPayment &&
      // We need to ignore this check since the Examiner can override the date/time
      //  this.originalCheckRideRequest?.CheckRideRequestSubStatusId != CheckRideRequestSubStatusAllItems.AcceptedPendingPayment &&
      this.originalCheckRideRequest?.CheckRideRequestSubStatusId != CheckRideRequestSubStatusAllItems.Rejected
    ) {
      if (this.formApi.getFormConfig().formMode == DwFormContextMode.edit) {
        return of(result);
      }
    }

    return this.checkCalendarAvailability()
      .pipe(map(availability => {
        if (availability.HasConflicts) {
          result.abort = true;
          result.message = 'The scheduled date/time is no longer available on the Examiners calendar. Please select a new date/time.';

          // Recheck the schedule since it's now no longer avaialble
          setTimeout(() => {
            this.examinerScheduleRechecked = false;
            this.recheckExaminerSchedule();
          }, 200);
        }

        return result;
      }));
  }

  setupDataWatch() {
    this.formApi.getFormDataChanges(100)
      .subscribe(dataChange => {
        if (this.formApi.isDataLoadComplete) {
          this.checkForDataChange();
        }
      });

    if (this.formApi.isDataLoadComplete) {
      this.checkForDataChange();
    }
  }

  private checkForDataChange() {

    const checkRideRequest = this.formApi.getFormData<CheckRideRequestEntity>();

    this.checkRideRequest = checkRideRequest;

    if (!this.originalCheckRideRequest) {
      this.originalCheckRideRequest = checkRideRequest;
    }

    this.fillInMissingDefaults();

    this.recheckExaminerSchedule();

    this.checkForActiveCheckrides(false);

    this.setupRebook();

    this.lastCheckRideRequest = checkRideRequest;
  }

  fillInMissingDefaults() {
    const checkrideRequest: Partial<CheckRideRequestEntity> = {};

    let hasUpdates = false;

    if (!this.checkRideRequest.StudentApplicantId) {
      console.log('Missing Student Application Id, populating');

      const studentContext = this.context[CurrentStudentContext]?.value as StudentApplicantEntity;

      if (studentContext?.StudentApplicantId) {
        checkrideRequest.StudentApplicantId = studentContext?.StudentApplicantId;
        checkrideRequest.AviationAuthorityId = studentContext?.AviationAuthorityId || 1;

        hasUpdates = true;
      };
    }

    if (!this.checkRideRequest?.CheckRideRequestSubStatusId) {
      checkrideRequest.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.PendingApproval;

      hasUpdates = true;
    }

    if (hasUpdates) {
      this.formApi.patchFormData(checkrideRequest);
    }


    //if (!this.checkRideRequest) {
    this.setAcsTest();
    //}
  }

  // setAcsTest() {
  //   if (!this.checkRideRequest?.CheckRideTypeId) {
  //     return;
  //   }

  //   if (this.checkRideRequest?.ApplicantAcsWrittenResult?.AcsTestId && this.lastCheckRideRequest?.CheckRideTypeId == this.checkRideRequest.CheckRideTypeId) {
  //     return;
  //   }

  //   console.log('Setting Acs Test from Checkride Type Id - ', this.checkRideRequest.CheckRideTypeId);

  //   this.planOfActionRepositoryService.getAcsTestByCheckRideType(this.checkRideRequest?.CheckRideTypeId)
  //     .subscribe(acsTestCheckRideType => {

  //       const checkrideRequest = this.formApi.getFormData<CheckRideRequestEntity>();

  //       if (acsTestCheckRideType?.AcsTestId) {
  //         if (checkrideRequest.ApplicantAcsWrittenResult?.AcsTestId == acsTestCheckRideType.AcsTestId) {
  //           return;
  //         }

  //         if (checkrideRequest.ApplicantAcsWrittenResult == null) {
  //           checkrideRequest.ApplicantAcsWrittenResult = AppMetaData.ApplicantAcsWrittenResult.CreateEntity();
  //         }

  //         const checkrideRequestUpdate: Partial<CheckRideRequestEntity> = {
  //           ApplicantAcsWrittenResult: deepCopy(this.checkRideRequest.ApplicantAcsWrittenResult)
  //         };

  //         checkrideRequestUpdate.ApplicantAcsWrittenResult.AcsTestId = acsTestCheckRideType.AcsTestId;

  //         this.formApi.patchFormData(checkrideRequestUpdate);
  //       }
  //     });
  // }


  setAcsTest() {
    if (!this.checkRideRequest?.CheckRideTypeId || !this.allAcsTests) {
      return;
    }

    const checkrideUpdate: Partial<CheckRideRequestEntity> = {};

    // if (this.checkRideRequest?.ApplicantAcsWrittenResult?.AcsTestId && this.lastCheckRideRequest?.CheckRideTypeId == this.checkRideRequest.CheckRideTypeId) {
    //   return;
    // }

    const acsTestCheckRideType = this.allAcsTests.find(a => a.CheckRideTypeId == this.checkRideRequest.CheckRideTypeId);

    let updated = false;

    if (!acsTestCheckRideType?.AcsTestId) {
      if (!this.checkRideRequest?.ApplicantAcsWrittenResult?.AcsTestId) {
        return;
      }
      checkrideUpdate.ApplicantAcsWrittenResult = deepCopy(checkrideUpdate.ApplicantAcsWrittenResult) || AppMetaData.ApplicantAcsWrittenResult.CreateEntity();
      checkrideUpdate.ApplicantAcsWrittenResult.AcsTestId = null;
      updated = true;
    }


    if (acsTestCheckRideType && this.checkRideRequest.ApplicantAcsWrittenResult?.AcsTestId != acsTestCheckRideType.AcsTestId) {
      checkrideUpdate.ApplicantAcsWrittenResult = deepCopy(checkrideUpdate.ApplicantAcsWrittenResult) || AppMetaData.ApplicantAcsWrittenResult.CreateEntity();

      //this.schoolDebug('Setting Acs Test from Checkride Type Id - ', this.checkRideRequest.CheckRideTypeId);
      checkrideUpdate.ApplicantAcsWrittenResult.AcsTestId = acsTestCheckRideType.AcsTestId;

      updated = true;
    }

    if (updated) {
      this.formApi.patchContextData(DwMdFormContextInfo.DATA_CONTEXT_NAME, checkrideUpdate);
      this.formApi.formGroup.patchValue(checkrideUpdate);
      this.formApi.patchFormData(checkrideUpdate);
    }

  }

  checkForActiveCheckrides(forceCheck: boolean) {
    if ((this.activeCheckrideChecked && !forceCheck) || !this.checkRideRequest) {
      return;
    }

    this.activeCheckrideChecked = true;

    if (this.dwMetaDataFormStateService.state.formContext.contextMode != DwFormContextMode.add) {
      return;
    }

    //if (!this.checkRideRequest.CheckRideRequestId)

    this.applicantRepositoryService.getActiveCheckrides(this.checkRideRequest.CheckRideRequestId)
      .subscribe(activeCheckrides => {
        const variables: Partial<ExaminerBookingVariableContext> = {};

        variables.Active_Checkrides_Exists = activeCheckrides.length > 0;

        this.formApi.patchVariableContext(variables);
      });
  }

  recheckExaminerSchedule() {
    if (this.examinerScheduleRechecked || !this.checkRideRequest) {
      return;
    }


    // This logic is handled in the ScheduleHoldInfo component now
    return;

    // this.examinerScheduleRechecked = true;

    // // Don't check unless we're editing (it was only checking on add, but that doesn't make sense)
    // if (this.formApi.getFormConfig().formMode != DwFormContextMode.edit) {
    //   return;
    // }

    // if (this.checkRideRequest?.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.Draft ||
    //   this.checkRideRequest?.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.PendingPayment ||
    //   this.checkRideRequest?.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.Rejected
    // ) {

    //   this.checkCalendarAvailability()
    //     .subscribe(availability => {
    //       if (availability.HasConflicts) {
    //         const checkrideRequest: Partial<CheckRideRequestEntity> = {
    //           PreferredDateTime: this.dateTimeUtilService.getCurrentDateTime(),
    //         };

    //         this.formApi.patchFormData(checkrideRequest);

    //         const variables = this.formApi.getVariableContextValue<ApplicantCheckrideVariables>();

    //         if (this.checkRideRequest?.CheckRideRequestSubStatusId != CheckRideRequestSubStatusAllItems.Rejected) {
    //           variables.Show_Search = true;
    //           variables.Preferred_Pilot_Examiner_Id = this.checkRideRequest.ScheduledPilotExaminerId;
    //         }

    //         variables.Checkride_Date_No_Longer_Valid = true;

    //         this.formApi.patchVariableContext(variables);
    //       }
    //     });
    // }
  }

  checkCalendarAvailability(): Observable<CheckCalendarAvailabilityResultDTO> {
    if (!this.checkRideRequest) {
      return of(null);
    }

    //this.examinerScheduleRechecked = true;

    const request: CheckCalendarAvailabilityRequestDTO = {
      CheckRideDateTime: this.checkRideRequest.ScheduledDateTime,
      DurationMinutes: this.checkRideRequest.ScheduledTimeMinutes,
      PilotExaminerId: this.checkRideRequest.ScheduledPilotExaminerId,
      FlightSchoolExaminerId: this.checkRideRequest.FlightSchoolExaminerId,
      CheckRideExaminerTypeId: this.checkRideRequest.CheckRideExaminerTypeId,
      CheckRideRequestId: this.checkRideRequest.CheckRideRequestId
    };

    return this.examinerRepositoryService.checkCalendarAvailability(request);

    // .subscribe(availability => {
    //   if (availability.HasConflicts) {
    //     const checkrideRequest: Partial<CheckRideRequestEntity> = {
    //       PreferredDateTime : this.dateTimeUtilService.getCurrentDateTime(),
    //     };

    //     this.formApi.patchFormData(checkrideRequest);

    //     const variables = this.formApi.getVariableContextValue<ApplicantCheckrideVariables>();

    //     if (this.checkRideRequest?.CheckRideRequestSubStatusId != CheckRideRequestSubStatusAllItems.Rejected) {
    //       variables.Show_Search = true;
    //       variables.Preferred_Pilot_Examiner_Id = this.checkRideRequest.ScheduledPilotExaminerId;
    //     }

    //     variables.Checkride_Date_No_Longer_Valid = true;

    //     this.formApi.patchVariableContext(variables);
    //   }
    // });

  }

  setupRebook() {
    // We want to wait until the defaults have been loaded
    if (!this.dwMetaDataFormStateService.state.formContext.defaultsProcessed) {
      return;
    }

    const variables = this.formApi.getVariableContextValue<ExaminerBookingVariableContext>();

    if (!variables?.RebookCheckrideId) {
      return;
    }

    if (!variables.Rebook_Pilot_Examiner_Id) {
      this.rebookSetupComplete = false;
    }

    if (this.rebookSetupComplete) {
      return;
    }

    this.rebookSetupComplete = true;

    // Use the loaded checkride if it is already loaded
    let ob = of(this.applicantCheckride);

    if (!this.applicantCheckride) {
      ob = this.applicantRepositoryService.getApplicantCheckrideRequest(variables.RebookCheckrideId)
    }

    ob.subscribe(checkride => {
      this.applicantCheckride = checkride;
      // Wait a half second to make sure the form is loaded
      setTimeout(() => {
        this.updateCheckride(checkride);
      });
    });
  }

  updateCheckride(checkride: CheckRideRequestEntity) {
    if (!checkride) {
      return;
    }

    const updatedCheckride = this.examinerRepositoryService.prepareCheckrideForCopy(checkride, this.testTypes, this.outcomes);

    let waivePayment = this.examinerRepositoryService.getWaiveCheckridePaymentOnRebook(checkride);

    // Set the preferred pilot examiner to the same as before
    const variables: Partial<ExaminerBookingVariableContext> = {
      Preferred_Pilot_Examiner_Id: checkride.ScheduledPilotExaminerId,
      Pilexos_Payment_Waived: waivePayment,
      Examiner_Rebook_Cost: checkride.CheckRideResult?.RetestCost,
      Rebook_Pilot_Examiner_Id: checkride.ScheduledPilotExaminerId,
      Show_Search: true
    };

    this.formApi.patchVariableContext(variables);

    updatedCheckride.PilexosBookingPaymentAdded = waivePayment;

    // Clear scheduled fields
    updatedCheckride.ScheduledDateTime = null;
    updatedCheckride.ScheduledPilotExaminerId = null;
    updatedCheckride.ExaminerBookingCost = checkride.ExaminerBookingCost;

    this.formApi.patchFormData(updatedCheckride);
  }

}

